import { Controller } from "@hotwired/stimulus";
import { Dropdown } from "bootstrap";

// Il menu deve uscire dal contenitore con scorrimento della tabella.
export default class extends Controller {
  connect() {
    this.dropdown = new Dropdown(this.element, {
      autoClose: "outside",
      popperConfig: (config) => ({ ...config, strategy: "fixed" })
    });
  }

  disconnect() {
    this.dropdown.dispose();
  }
}
